export default __webpack_public_path__ + "static/media/cdt.136d030e.png";